const API_URL = {
    CREDENTIAL_API: window._env_?.CREDENTIAL_API || process.env.REACT_APP_CREDENTIAL_API,
    PROVISION_API: window._env_?.PROVISION_API || process.env.REACT_APP_PROVISION_API,
    STATEFILE_API: window._env_?.STATEFILE_API || process.env.REACT_APP_STATEFILE_API,
    STATEFILE_IMPORT_API: window._env_?.STATEFILE_IMPORT_API || process.env.REACT_APP_STATEFILE_IMPORT_API,
    CLIENT_ID: window._env_?.AZURE_CLIENT_ID || process.env.REACT_APP_AZURE_CLIENT_ID,
    TENANT_ID: window._env_?.AZURE_TENANT_ID || process.env.REACT_APP_AZURE_TENANT_ID,
    REDIRECT_URI: window._env_?.AZURE_REDIRECT_URI || process.env.REACT_APP_AZURE_REDIRECT_URI,
}
export default API_URL